import React from 'react';
import classnames from 'classnames';
import PropTypes from "prop-types";

const TabContent = ({
    isActive,
    content,
    bgColorClass = "gray-bg"
}) => {
    return <div className={classnames("tab-pane", bgColorClass, {"active":isActive})}>
        <div className="panel-body">
            {isActive && content}
        </div>
    </div>;
};

TabContent.propTypes = {
    isActive: PropTypes.bool.isRequired,
    content: PropTypes.any.isRequired,
    bgColorClass: PropTypes.string
};

export default TabContent;